import React from 'react';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { useHistory } from 'react-router-dom';
import ProfileImage from '../../../common/ProfileImage/ProfileImage';

const MenuProfileMobile = ({ user, fetchingProfile, logout, setIsMenuOpen }) => {
    const history = useHistory();
    const isPro = user.isPro && !fetchingProfile;

    const logoutProfile = () => {
        logout();

        setIsMenuOpen(false);
    };

    const goToEditProfile = () => {
        history.push('/perfil/editar-perfil');

        setIsMenuOpen(false);
    };

    return (
        <div className="tw-flex tw-items-center tw-justify-between" role="menu">
            <button
                type="button"
                aria-label="Meu perfil"
                onClick={goToEditProfile}
                className="tw-flex tw-items-center tw-gap-3 tw-cursor-pointer"
                role="menuitem"
            >
                <ProfileImage name={user.name || '?'} lastName={user.lastName} size={12} isPro={isPro} />
                <span>Meu perfil</span>
            </button>
            <button
                type="button"
                aria-label="Sair"
                onClick={logoutProfile}
                className="tw-flex tw-items-center tw-gap-3 tw-cursor-pointer"
                role="menuitem"
            >
                <span>Sair</span>
                <FontAwesomeIcon icon={faArrowRightFromBracket} color="#777C86" />
            </button>
        </div>
    )
}

MenuProfileMobile.propTypes = exact({
    user: PropTypes.object.isRequired,
    fetchingProfile: PropTypes.bool,
    logout: PropTypes.func.isRequired,
    setIsMenuOpen: PropTypes.func.isRequired,
});

export default MenuProfileMobile;
